export default "__VITE_ASSET__BBnpOlWy__"